module.exports = __webpack_public_path__ + "media/welcome-message/webinar@2x-e4fa0c7b.png";